import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import './LogoSplash.css';

const LogoSplash = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const logoRef = React.useRef(null);
  const containerRef = React.useRef(null);

  useEffect(() => {
    const logo = logoRef.current;
    const container = containerRef.current;

    if (!logo || !container) return;

    // Başlangıç animasyonu - Logo fade in
    gsap.set(logo, {
      opacity: 0,
      scale: 0.5
    });

    // Logo görünür hale gel
    gsap.to(logo, {
      opacity: 1,
      scale: 1,
      duration: 1,
      ease: 'power3.out',
      delay: 0.3
    });

    // Logo büyüme animasyonu ve ana sayfaya geçiş
    const timeline = gsap.timeline({
      delay: 2, // 2 saniye bekle
      onComplete: () => {
        // Container'ı fade out yap
        gsap.to(container, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.in',
          onComplete: () => {
            setIsVisible(false);
            onComplete?.();
          }
        });
      }
    });

    // Logo büyüme animasyonu
    timeline.to(logo, {
      scale: 15,
      opacity: 0,
      duration: 1,
      ease: 'power2.inOut'
    });
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div ref={containerRef} className="logo-splash">
      <div className="logo-splash-background"></div>
      <img 
        ref={logoRef}
        src="/images/logo.png" 
        alt="Digitalentra Logo" 
        className="logo-splash-image"
      />
    </div>
  );
};

export default LogoSplash;

